import React from "react";

import * as styles from "./ModalClose.css";

export const ModalClose = ({
  width = 14,
  height = 15,
}: {
  width?: number;
  height?: number;
}): React.ReactElement => (
  <svg viewBox="0 0 14 15" width={width} height={height}>
    <g transform="translate(-1)" fillRule="evenodd" className={styles.modalClose}>
      <rect transform="rotate(45 8 7.5)" x={7} y={-2} width={2} height={19} rx={1} />
      <rect transform="rotate(-45 8 7.5)" x={7} y={-2} width={2} height={19} rx={1} />
    </g>
  </svg>
);
